"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const __enums_1 = require("../../../../__types/__enums");
const getElasticsearchQueryFromFilters_1 = require("../../../__common/elasticsearchQuery/getElasticsearchQueryFromFilters");
const getElasticsearchSortForSortParams_1 = require("../../../__common/elasticsearchQuery/getElasticsearchSortForSortParams");
const reportHelpers_1 = require("../../../__common/reportHelpers");
const dashboardsByQuery_1 = require("../../dashboardsByQuery");
function getAllDashboards(rp, input) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { ReportParams: reportParmas, ReportProjection = {} } = input;
        const { dashboardProjection } = ReportProjection;
        const { filters } = reportParmas;
        const sortParams = input.SortParams;
        const query = getElasticsearchQueryFromFilters_1.getElasticsearchQueryForFilters(filters.dashboardFilters);
        if (Object.keys(query.bool).length > 0) {
            const { dashboards, total } = yield dashboardsByQuery_1.getDashboardsByQuery({
                requestType: __enums_1.ReportRequestTypeEnum.ALL,
                _source: dashboardProjection,
                size: 300,
                body: { query },
                sort: getElasticsearchSortForSortParams_1.getElasticsearchSortForSortParams(sortParams || [])
            });
            // Fetching and setting related users like reviewer, assigner
            if (ReportProjection.relatedUserProjection) {
                yield reportHelpers_1.setRelatedUsers(rp, ReportProjection.relatedUserProjection, dashboards);
            }
            return { dashboards, total };
        }
        return { dashboards: [], total: 0 };
    });
}
exports.getAllDashboards = getAllDashboards;
//# sourceMappingURL=index.js.map